import React, { useEffect } from "react";
import {
  Box,
  Typography,
  Button,
  MobileStepper,
  IconButton,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import ImgPath from "../../Constants/Imgs";
import ColorData from "../../Components/CstmTheme/ColorData";

const carouselItems = [
  {
    title: "Third-Party Litigation Funding",
    desc: "Trusted legal partners providing expert solutions with integrity and excellence.",
    img: ImgPath.HomeSlider,
  },
  {
    title: "Online Mediation",
    desc: "Trusted legal partners providing expert solutions with integrity and excellence.",
    img: ImgPath.HomeSlider,
  },
  {
    title: "Call the Expert",
    desc: "Trusted legal partners providing expert solutions with integrity and excellence.",
    img: ImgPath.HomeSlider,
  },
  {
    title: "Setup Business",
    desc: "Trusted legal partners providing expert solutions with integrity and excellence.",
    img: ImgPath.HomeSlider,
  },
];

const HeroCarousel = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [activeStep, setActiveStep] = React.useState(0);
  const maxSteps = carouselItems.length;

  const handleNext = () => {
    setActiveStep((prev) => (prev + 1) % maxSteps);
  };

  const handleBack = () => {
    setActiveStep((prev) => (prev - 1 + maxSteps) % maxSteps);
  };

  useEffect(() => {
    const timer = setInterval(() => {
      handleNext();
    }, 4000);
    return () => clearInterval(timer);
  }, [activeStep]);

  return (
    <Box
      sx={{
        position: "relative",
        overflow: "hidden",
        height: { xs: 400, md: 500 },
        width: "100%",
      }}
    >
      <Box
        component="img"
        src={carouselItems[activeStep].img}
        alt={carouselItems[activeStep].title}
        sx={{ width: "100%", height: "100%", objectFit: "cover" }}
      />
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          color: "#fff",
          textAlign: "center",
          px: 2,
        }}
      >
        <Typography
          variant={isMobile ? "h4" : "h3"}
          component="h1"
          className="fadeInUp delay-1"
          sx={{ fontWeight: "bold" }}
          color={ColorData.text.primary}
        >
          {carouselItems[activeStep].title}
        </Typography>
        <Typography
          variant="body1"
          className="fadeInUp delay-2"
          sx={{ mt: 2, mb: 3 }}
          color={ColorData.text.black}
        >
          {carouselItems[activeStep].desc}
        </Typography>
        <Box className="fadeInUp delay-3" display="flex" gap={2}>
          <Button variant="contained" color="primary">
            View More
          </Button>
          <Button variant="outlined" color="primary">
            Contact Us
          </Button>
        </Box>
      </Box>
      <MobileStepper
        steps={maxSteps}
        position="static"
        activeStep={activeStep}
        nextButton={
          <IconButton
            size="small"
            onClick={handleNext}
            sx={{ color: "primary.main" }}
          >
            <KeyboardArrowRight />
          </IconButton>
        }
        backButton={
          <IconButton
            size="small"
            onClick={handleBack}
            sx={{ color: "primary.main" }}
          >
            <KeyboardArrowLeft />
          </IconButton>
        }
        sx={{
          position: "absolute",
          bottom: 10,
          left: "50%",
          transform: "translateX(-50%)",
          backgroundColor: "transparent",
          color: "#fff",
        }}
      />
    </Box>
  );
};

export default HeroCarousel;
